import React from 'react';
import { isArray, isEmpty } from 'lodash';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';

import withErrorHandler from '../../hoc/with-error-handler';
import axios from '../../shared/axios';

import { ClockCircleTwoTone } from '@ant-design/icons';
import { App, Button, Space } from 'antd';

import { apiOptions, siteUrls } from '../../shared/constants';

import * as sharedActions from '../../shared/store/actions';
import * as actions from './store/actions';

import { AppDispatch, RootState } from '../../store';

import pieceOfCakeSound from '../../assets/sounds/piece-of-cake-611.mp3';
import { RemainderNotification, SystemMessagesReminders } from '../../shared/models';
import { ArgsProps } from 'antd/es/notification';

let isPlayAudioBusy = false;

export type ReminderNotificationPopupComponentProps = {
  userId: string;
  agencyId: string;
  databaseId: string;
  timeZoneId: string;
};

const ReminderNotificationPopupComponent = ({ userId, agencyId, databaseId, timeZoneId }: ReminderNotificationPopupComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const didMount = useRef(false);

  const { notification } = App.useApp();

  const { remainderNotificationMessage } = useSelector((state: RootState) => state.webSocket);

  const playAudio = (audio: HTMLAudioElement) => {
    if (!isPlayAudioBusy) {
      audio.play();
      audio.onended = () => (isPlayAudioBusy = false);
    }
  };

  useEffect(() => {
    if (!didMount.current) {
      dispatch(
        sharedActions.sendMessage({
          isRemainderNotification: true,
          userId: userId,
          agencyId: agencyId,
          databaseId: databaseId,
          timeZoneId: timeZoneId,
        }),
      );

      didMount.current = true;
    }
  }, []);

  const handleClose = (notificationId: string, isSystemMessage: boolean, afterClose: Function | null) => {
    dispatch(actions.markNotificationAsRead(notificationId, isSystemMessage)).then(() => {
      notification.destroy(notificationId);

      if (typeof afterClose === 'function') {
        afterClose();
      }
    });
  };

  const handleClickSystemMessageDetails = (e: any, detailsUrl: string, notificationId: string, isSystemMessage: boolean) => {
    e.preventDefault();
    e.stopPropagation();

    handleClose(notificationId, isSystemMessage, () => {
      window.location.href = detailsUrl;
    });
  };

  const handleRemindLater = (notificationId: string) => {
    dispatch(actions.markAsRemindLater(notificationId)).then(() => {
      notification.destroy(notificationId);
    });
  };

  useEffect(() => {
    if (remainderNotificationMessage && remainderNotificationMessage.isRemainderNotification === true) {
      if (isArray(remainderNotificationMessage.notifications) && !isEmpty(remainderNotificationMessage.notifications)) {
        notification.destroy();

        remainderNotificationMessage.notifications.forEach((item: RemainderNotification | SystemMessagesReminders) => {
          let placement;
          let style;
          let icon;
          let title;
          let content;
          let isSystemMessage = false;

          if ('sendingDateUserLocal' in item && item.sendingDateUserLocal) {
            placement = 'topLeft';
            style = null;
            icon = <ClockCircleTwoTone />;
            title = `Reminder ${moment(item.sendingDateUserLocal).format('MMM DD, YYYY, hh:mm A')}`;
            content = (
              <>
                {item.text}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '15px',
                  }}
                >
                  <Space>
                    <Button type="primary" size="small" ghost onClick={() => handleRemindLater(item.id)}>
                      Remind me later
                    </Button>
                    <Button type="primary" size="small" onClick={() => handleClose(item.id, false, null)}>
                      Dismiss
                    </Button>
                  </Space>
                </div>
              </>
            );
          }

          if ('isSystemMessage' in item && item.isSystemMessage) {
            isSystemMessage = item.isSystemMessage;
            const detailsUrl = `${siteUrls.systemMessagesMomentum}${item.id}`;

            icon = null;
            title = item.titleFormatted;
            content = (
              <>
                {item.bodyFormatted}
                <br />
                <a href={detailsUrl} onClick={(e) => handleClickSystemMessageDetails(e, detailsUrl, item.id, item.isSystemMessage)}>
                  View Details
                </a>
              </>
            );
            placement = 'top';
            style = {
              width: '500px',
            };
          }

          notification.info({
            key: item.id,
            icon: icon,
            message: title,
            description: content,
            placement: placement,
            top: 55,
            style: style,
            duration: null, // will not close if null
            onClose: () => handleClose(item.id, isSystemMessage, null),
          } as ArgsProps);
        });

        if (localStorage.getItem('reactTabKey')?.toString() === (window as any).reactTabKey.toString()) {
          playAudio(new Audio(`${apiOptions.appAssetsRootPath}${pieceOfCakeSound}`));
        }
      }
    }
  }, [remainderNotificationMessage]);

  return <React.Fragment> </React.Fragment>;
};

export default withErrorHandler(ReminderNotificationPopupComponent, axios);
